export default "__VITE_ASSET__DdEbcPYE__"